import React from "react";
import Modal from "@components/ModalTemplate";
import NiceModal, { useModal } from "@ebay/nice-modal-react";
import Button from "@components/Button";
import SectionHeader from "../SectionHeader";
import BrandLogo from "../BrandLogo";
import "./style.scss";
import IMGMobile from "@assets/trash/redeem/main-img-mobile.jpg";
import { useNavigate } from "react-router";
import DOMPurify from "dompurify";

export default NiceModal.create(() => {
  const modal = useModal();

  const {
    onClose,
    title,
    img,
    awardName,
    awardDesc,
    buttonCopy
  } = modal.args

  return (
    <Modal
      isOpen={modal.visible}
      onClose={() => {
        onClose()
        modal.hide();
      }}
      onAfterClose={() => modal.remove()}
      innerClass={"redeem-award-modal"}
    >
      <SectionHeader dangerouslySetInnerHTML={title} />
      <div className="desktop-wrapper">
        <div className="img-wrapper">
          <img src={img} alt="" />
          <BrandLogo />
        </div>
        <div className="copy">
          {awardName && <p
            className="award-name"
            dangerouslySetInnerHTML={{
              __html: DOMPurify.sanitize(awardName),
            }}
          />}
          {awardDesc && (
            <p
              className="award-desc"
              dangerouslySetInnerHTML={{
                __html: DOMPurify.sanitize(awardDesc),
              }}
            />
          )}
        </div>
      </div>
      <div className="buttons-wrapper">
        <Button
          action={() => {
            onClose()
            modal.hide();
          }}
        >
          {buttonCopy ?? "Weiter"}
        </Button>
      </div>
    </Modal>
  );
});
